import { Input } from '@/components/ui/input'
import { SelectField, SelectFieldOption } from '@/components/ui/select'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { AcceptanceStatusFilter } from '@/modules/Regulations/types'
import { Search } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
    status: AcceptanceStatusFilter
    onStatusChange: (status: AcceptanceStatusFilter) => void
    search: string
    onSearchChange: (search: string) => void
    regulationVersion: string
    onRegulationVersionChange: (version: string) => void
    versionOptions: SelectFieldOption[]
    currentActiveVersion?: string
}

const RegulationAcceptanceFilters: React.FC<Props> = ({
    status,
    onStatusChange,
    search,
    onSearchChange,
    regulationVersion,
    onRegulationVersionChange,
    versionOptions,
    currentActiveVersion,
}) => {
    const { t } = useTranslation()

    return (
        <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
            <Tabs
                value={status}
                onValueChange={(v) =>
                    onStatusChange(v as AcceptanceStatusFilter)
                }
            >
                <TabsList>
                    <TabsTrigger value="all">{t('all')}</TabsTrigger>
                    <TabsTrigger value="accepted">{t('accepted')}</TabsTrigger>
                    <TabsTrigger value="not_accepted">
                        {t('not-accepted')}
                    </TabsTrigger>
                </TabsList>
            </Tabs>

            <div className="flex items-center gap-2 flex-wrap">
                {currentActiveVersion && (
                    <span className="text-xs text-muted-foreground whitespace-nowrap">
                        {t('settings:current-active-version')}:{' '}
                        <span className="font-mono font-medium">
                            v{currentActiveVersion.replace(/^v/i, '')}
                        </span>
                    </span>
                )}
                <div className="w-full md:w-[180px]">
                    <SelectField
                        value={regulationVersion}
                        onValueChange={onRegulationVersionChange}
                        options={versionOptions}
                        placeholder={t('settings:filter-by-version')}
                        size="sm"
                    />
                </div>
                <div className="relative w-full md:w-[260px]">
                    <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                    <Input
                        value={search}
                        onChange={(e) => onSearchChange(e.target.value)}
                        placeholder={t('settings:search-by-name-or-email')}
                        className="pl-8"
                    />
                </div>
            </div>
        </div>
    )
}

export default RegulationAcceptanceFilters
